export interface SnackBarType {
  isOpen: boolean
  isError: boolean
  message: string
  duration?: number
}

interface PageStateType {
  snackBar: SnackBarType
}

export const pageState: PageStateType = {
  snackBar: { isOpen: false, isError: false, message: '', duration: 0 },
}
